module.exports = __webpack_public_path__ + "static/img/home_bt2.7271a6d5.png";